module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("HighLandirect")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised"
  }, [_vm._v("印刷！")]), _vm._v(" "), _c('span', [_vm._v("ソース："), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/koty/HighLandirectWebFront"
    }
  }, [_vm._v("https://github.com/koty/HighLandirectWebFront")])])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("top")])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/customers"
    }
  }, [_vm._v("顧客一覧")])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/orders"
    }
  }, [_vm._v("注文一覧")])], 1), _vm._v(" "), _c('md-button', [_c('router-link', {
    attrs: {
      "to": "/orders/o2"
    }
  }, [_vm._v("注文一覧/o2")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20879349","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 206
// module chunks = 1